import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditCvTipoZonaIva extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoZonaIva.id ? this.props.cvTipoZonaIva.id : uuidv4(),
            description: this.props.cvTipoZonaIva.descr ? this.props.cvTipoZonaIva.descr : ''

        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'description'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary"  onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoZonaIva = {
                            id: this.state.id,
                            descr: this.state.description,
                        }

                        if (this.props.checkTipoZonaIva(tipoZonaIva)) {
                        
                            this.props.okHandler(tipoZonaIva);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditCvTipoZonaIva.propTypes = {
    cvTipoZonaIva: PropTypes.object.isRequired,
    checkTipoZonaIva: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvTipoZonaIva);